export default __webpack_public_path__ + "static/media/quiz-bizz.07ea7d1f.svg";